if $ == undefined
  $ = jQuery

window.ta_validator = {}
window.ta_validator.email_regexp = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/

window.ta_validator.presence = (input, default_value="") ->
  value = (input.val() or "").toString().trim()
  return !(value == "" || value == default_value)

window.ta_validator.format = (input, pattern) ->
  value = input.val()
  return pattern.test(value)

window.ta_validator.addError = (input, message, options={}) ->
  error_class = if options.error_class? then options.error_class else "error-msg"
  error_color = if options.error_color? then options.error_color else "#ff0000"
  border_width = if options.border_width? then options.border_width else "1px"
  input.css('border',"#{border_width} solid #{error_color}")
  if input.next("div.#{error_class}").length == 0
    mb = input.css('margin-bottom')
    ml = parseInt(input.prev('label').css('margin-right'),10)+input.prev('label').width()+parseInt(input.css('padding-left'),10)
    ml = "#{ml}px"
    input.css('margin-bottom','0px')
    if input.attr('type') == 'checkbox'
      input.parent().append "<div class='#{error_class}' style='display:block; color: #{error_color}; margin-bottom: #{mb}; margin-left: #{ml};'><b>#{message}</b></div>"
    else
      input.after "<div class='#{error_class}' style='display:block; color: #{error_color}; margin-bottom: #{mb}; margin-left: #{ml};'><b>#{message}</b></div>"
  else
    input.next("div.#{error_class}").fadeIn('fast')

window.ta_validator.removeError = (input, options={}) ->
  error_class = if options.error_class? then options.error_class else "error-msg"
  normal_color = if options.normal_color? then options.normal_color else "#B7B7B7"
  remove = if options.remove? then options.remove else true
  border_width = if options.border_width? then options.border_width else "1px"
  msg = input.next("div.#{error_class}")
  mb = msg.css('margin-bottom')
  input.css('border',"#{border_width} solid #{normal_color}").css('margin-bottom',mb)
  msg.fadeOut("fast")
  if remove
    msg.remove()